module.exports = __webpack_public_path__ + "img/samia.f908a335.png";